'use client';
function conditionalPropType(n, o, r) {
    return function(t, e, i, u, c, ...p) {
        return n(t, e, i, u, c) ? o(t, e, i, u, c, ...p) : r(t, e, i, u, c, ...p);
    };
}

export { conditionalPropType };
